import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { DetectPlatformService } from '../../../services/detectPlatform.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'landing-start-using-bar',
  templateUrl: './start-using-bar.component.html',
  styleUrls: ['./start-using-bar.component.scss'],
})

export class LandingStartUsingBarComponent implements OnInit {
  public barIsFixed = false;
  lastPageYOffset = 0;

  constructor(
    public detectPlatformServiceBar: DetectPlatformService,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  ngOnInit() { }

  @HostListener('window:scroll', ['$event'])
    onWindowScroll($event) {
    let scrollTop = false;
    const number = this.document.documentElement.scrollTop || this.document.body.scrollTop || 0;

    if (number < this.lastPageYOffset) {
      scrollTop = true;
    } else {
      scrollTop = false;
    }

    this.lastPageYOffset = number;
    const visibilityBreakpoint = 2520;

    if (number > visibilityBreakpoint) {
      if (scrollTop === true) {
        this.barIsFixed = true;
      }
    } else if (this.barIsFixed && number < visibilityBreakpoint) {
      this.barIsFixed = false;
    }
  }
}
